import { Body1, Button, makeStyles } from "@fluentui/react-components";
import React from "react";
import { landing } from "../../../strings";
import { useAuthDialog } from "./useAuthDialog";

const pagestr = landing();

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    backgroundColor: "#ffffff",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 1.5rem",
    textAlign: "center",
  },
  main: {
    height: "90vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    width: "300px",
  },
  title: {
    color: "white",
    margin: "0 0 -1rem 0",
    paddingBottom: "0",
    fontFamily: "Arial, sans-serif",
  },
  subtitle: {
    color: "#141414",
    maxWidth: "600px",
    paddingBottom: "1rem",
    paddingTop: "10px",
    marginTop: "0",
  },
  footer: {
    height: "20px",
    color: "#7F7979",
    maxWidth: "600px",
    paddingBottom: "1rem",
    paddingTop: "0",
    marginTop: "0",
  },
});

const LandingPage = () => {
  const styles = useStyles();
  const { isAuthenticating, openLoginDialog } = useAuthDialog();

  return (
    <div className={styles.root}>
      <div className={styles.main}>
        <img src="/assets/OmnisIQCounsel-Light.png" alt="Logo" className={styles.icon} />
        <Body1 as="p" className={styles.subtitle}>
          <span style={{ fontStyle: "italic" }}>{pagestr.subtitle}</span>
        </Body1>
        <Button appearance="primary" onClick={openLoginDialog} disabled={isAuthenticating}>
          {isAuthenticating ? pagestr.authenticating : pagestr.login}
        </Button>
      </div>
      <Body1 as="p" className={styles.footer}>
        <span style={{ fontStyle: "italic" }}>
          {pagestr.hidden_intel}
          <sup>{pagestr.trademark}</sup>
        </span>
      </Body1>
    </div>
  );
};

export { LandingPage };
